import { useCallback, useRef } from 'react';

/**
 * Com a busca ao digitar, respostas chegam fora de ordem: só a da última requisição vale (AJH-26).
 * `iniciar()` marca uma requisição nova e devolve `ehAUltima()`, que diz se nenhuma outra começou depois;
 * `descartar()` invalida a que estiver em andamento, sem começar outra.
 */
export function useRequisicaoMaisRecente() {
  const ultima = useRef(0);

  const iniciar = useCallback(() => {
    const esta = ++ultima.current;
    return () => esta === ultima.current;
  }, []);

  const descartar = useCallback(() => {
    ultima.current += 1;
  }, []);

  return { iniciar, descartar };
}
